import type { ReactNode } from "react";
import { LegalComercioFooter } from "../legal/LegalComercioFooter";

const bgStyle = { backgroundImage: "url('/fondo.webp')" } as const;

interface PublicPageFrameProps {
  children: ReactNode;
  /** Centra el contenido verticalmente (formularios públicos). */
  centered?: boolean;
}

export function PublicPageFrame({ children, centered = true }: PublicPageFrameProps) {
  return (
    <div
      className="flex min-h-screen w-full flex-col bg-cover bg-center bg-no-repeat"
      style={bgStyle}
    >
      <div
        className={
          centered
            ? "flex flex-1 items-center justify-center px-4 py-8 sm:py-12"
            : "flex flex-1 flex-col px-4 py-8"
        }
      >
        {children}
      </div>
      <LegalComercioFooter variant="onImage" />
    </div>
  );
}
